"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const React = require("react");
require("./modal.less");
const Typography_1 = require("@material-ui/core/Typography");
const button_1 = require("client/components/material/button");
const button_2 = require("client/components/ui/button");
const ramda_1 = require("ramda");
class Modal extends React.Component {
    constructor() {
        super(...arguments);
        this.handleCancelClick = () => {
            this.props.onCancel();
        };
    }
    componentWillUnmount() {
        if (typeof this.props.onClose !== "undefined") {
            this.props.onClose();
        }
    }
    render() {
        const { buttons = [], height = "min-content", title = "", borderRadius = "", width = "min-content", componentName = "", } = this.props;
        return (React.createElement("div", { className: "modal" },
            React.createElement("div", { className: "modal-background", onClick: this.handleCancelClick }),
            React.createElement("div", { className: "modal-body", style: {
                    height: `${height}`,
                    maxHeight: `${this.props.maxHeight}`,
                    top: `${this.props.top}`,
                    width: `${width}`,
                    borderRadius: `${borderRadius}`,
                } },
                title ? (React.createElement("div", { className: "modal-body-title" },
                    React.createElement(Typography_1.default, { variant: "headline", color: "inherit" }, title))) : null,
                React.createElement("div", { className: componentName === "patientReport" ? "" : " modal-body-content", style: {
                        overflowY: `${this.props.overflowY ? "initial" : "auto"}`
                    } }, this.props.children),
                componentName === "patientReport" ? ( //E-037.211
                null) : React.createElement("div", { className: "modal-body-buttons" }, buttons.map((child, i) => {
                    if (button_1.isMaterialButton(child) || button_2.isUiButton(child)) {
                        return ramda_1.merge(child, { key: i });
                    }
                    return (React.createElement(button_1.MaterialButton, { primary: true, key: i }, child));
                })))));
    }
}
exports.Modal = Modal;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/modal.tsx
// module id = 3207
// module chunks = 0